// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RegionDropdown-Item a img.RegionFlag[data-v-3e51543c]{box-shadow:0 0 0 .5px rgba(123,127,142,.5)}.RegionDropdown img.RegionFlag[data-v-3e51543c]{width:20px;height:20px;border-radius:50%;border:2px solid transparent;box-shadow:0 0 0 .5px #fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
